export const Types = [
    {
        actionName: 'initialAction',
        types: {
            INITIAL_ACTION: 'INITIAL_ACTION',
        },
    },
    {
        actionName: 'loginAction',
        types: {
            LOGIN_START: 'LOGIN_START',
            LOGIN_SUCCESS: 'LOGIN_SUCCESS',
            LOGIN_FAILED: 'LOGIN_FAILED',
            LOGIN_STOP: 'LOGIN_STOP',
        },
    },
    {
        actionName: 'dashboardAction',
        types: {
            ALL_PARTICIPANT_FETCH_START: 'ALL_PARTICIPANT_FETCH_START',
            ALL_PARTICIPANT_FETCH_SUCCESS: 'ALL_PARTICIPANT_FETCH_SUCCESS',
            ALL_PARTICIPANT_FETCH_FAILED: 'ALL_PARTICIPANT_FETCH_FAILED',
            ALL_PARTICIPANT_FETCH_STOP: 'ALL_PARTICIPANT_FETCH_STOP',
            ALL_PARTICIPANT_FETCH_EMPTY: 'ALL_PARTICIPANT_FETCH_EMPTY',

            SINGLE_PARTICIPANT_FETCH_START: 'SINGLE_PARTICIPANT_FETCH_START',
            SINGLE_PARTICIPANT_FETCH_SUCCESS:
                'SINGLE_PARTICIPANT_FETCH_SUCCESS',
            SINGLE_PARTICIPANT_FETCH_FAILED: 'SINGLE_PARTICIPANT_FETCH_FAILED',
            SINGLE_PARTICIPANT_FETCH_STOP: 'SINGLE_PARTICIPANT_FETCH_STOP',

            PARTICIPANT_CREATE_START: 'PARTICIPANT_CREATE_START',
            PARTICIPANT_CREATE_SUCCESS: 'PARTICIPANT_CREATE_SUCCESS',
            PARTICIPANT_CREATE_FAILED: 'PARTICIPANT_CREATE_FAILED',
            PARTICIPANT_CREATE_STOP: 'PARTICIPANT_CREATE_STOP',

            PARTICIPANT_UPDATE_START: 'PARTICIPANT_UPDATE_START',
            PARTICIPANT_UPDATE_SUCCESS: 'PARTICIPANT_UPDATE_SUCCESS',
            PARTICIPANT_UPDATE_FAILED: 'PARTICIPANT_UPDATE_FAILED',
            PARTICIPANT_UPDATE_STOP: 'PARTICIPANT_UPDATE_STOP',

            PARTICIPANT_DELETE_START: 'PARTICIPANT_DELETE_START',
            PARTICIPANT_DELETE_SUCCESS: 'PARTICIPANT_DELETE_SUCCESS',
            PARTICIPANT_DELETE_FAILED: 'PARTICIPANT_DELETE_FAILED',
            PARTICIPANT_DELETE_STOP: 'PARTICIPANT_DELETE_STOP',

            PARTICIPANT_ARCHIVE_START: 'PARTICIPANT_ARCHIVE_START',
            PARTICIPANT_ARCHIVE_SUCCESS: 'PARTICIPANT_ARCHIVE_SUCCESS',
            PARTICIPANT_ARCHIVE_FAILED: 'PARTICIPANT_ARCHIVE_FAILED',
            PARTICIPANT_ARCHIVE_STOP: 'PARTICIPANT_ARCHIVE_STOP',

            PARTICIPANT_UNARCHIVE_START: 'PARTICIPANT_UNARCHIVE_START',
            PARTICIPANT_UNARCHIVE_SUCCESS: 'PARTICIPANT_UNARCHIVE_SUCCESS',
            PARTICIPANT_UNARCHIVE_FAILED: 'PARTICIPANT_UNARCHIVE_FAILED',
            PARTICIPANT_UNARCHIVE_STOP: 'PARTICIPANT_UNARCHIVE_STOP',
        },
    },
    {
        actionName: 'userAction',
        types: {
            ALL_USER_FETCH_START: 'ALL_USER_FETCH_START',
            ALL_USER_FETCH_SUCCESS: 'ALL_USER_FETCH_SUCCESS',
            ALL_USER_FETCH_FAILED: 'ALL_USER_FETCH_FAILED',
            ALL_USER_FETCH_STOP: 'ALL_USER_FETCH_STOP',

            SINGLE_USER_FETCH_START: 'SINGLE_USER_FETCH_START',
            SINGLE_USER_FETCH_SUCCESS: 'SINGLE_USER_FETCH_SUCCESS',
            SINGLE_USER_FETCH_FAILED: 'SINGLE_USER_FETCH_FAILED',
            SINGLE_USER_FETCH_STOP: 'SINGLE_USER_FETCH_STOP',

            USER_CREATE_START: 'USER_CREATE_START',
            USER_CREATE_SUCCESS: 'USER_CREATE_SUCCESS',
            USER_CREATE_FAILED: 'USER_CREATE_FAILED',
            USER_CREATE_STOP: 'USER_CREATE_STOP',

            USER_UPDATE_START: 'USER_UPDATE_START',
            USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
            USER_UPDATE_FAILED: 'USER_UPDATE_FAILED',
            USER_UPDATE_STOP: 'USER_UPDATE_STOP',

            USER_DELETE_START: 'USER_DELETE_START',
            USER_DELETE_SUCCESS: 'USER_DELETE_SUCCESS',
            USER_DELETE_FAILED: 'USER_DELETE_FAILED',
            USER_DELETE_STOP: 'USER_DELETE_STOP',
        },
    },
    {
        actionName: 'tentAction',
        types: {
            ALL_TENT_FETCH_START: 'ALL_TENT_FETCH_START',
            ALL_TENT_FETCH_SUCCESS: 'ALL_TENT_FETCH_SUCCESS',
            ALL_TENT_FETCH_FAILED: 'ALL_TENT_FETCH_FAILED',
            ALL_TENT_FETCH_STOP: 'ALL_TENT_FETCH_STOP',

            SINGLE_TENT_FETCH_START: 'SINGLE_TENT_FETCH_START',
            SINGLE_TENT_FETCH_SUCCESS: 'SINGLE_TENT_FETCH_SUCCESS',
            SINGLE_TENT_FETCH_FAILED: 'SINGLE_TENT_FETCH_FAILED',
            SINGLE_TENT_FETCH_STOP: 'SINGLE_TENT_FETCH_STOP',

            TENT_CREATE_START: 'TENT_CREATE_START',
            TENT_CREATE_SUCCESS: 'TENT_CREATE_SUCCESS',
            TENT_CREATE_FAILED: 'TENT_CREATE_FAILED',
            TENT_CREATE_STOP: 'TENT_CREATE_STOP',

            TENT_UPDATE_START: 'TENT_UPDATE_START',
            TENT_UPDATE_SUCCESS: 'TENT_UPDATE_SUCCESS',
            TENT_UPDATE_FAILED: 'TENT_UPDATE_FAILED',
            TENT_UPDATE_STOP: 'TENT_UPDATE_STOP',

            TENT_DELETE_START: 'TENT_DELETE_START',
            TENT_DELETE_SUCCESS: 'TENT_DELETE_SUCCESS',
            TENT_DELETE_FAILED: 'TENT_DELETE_FAILED',
            TENT_DELETE_STOP: 'TENT_DELETE_STOP',
            RESET_TENT_STATUS: 'RESET_TENT_STATUS',
            UPDATE_TENT_LOCALLY: 'UPDATE_TENT_LOCALLY',

            PARTICIPANT_ASSIGNMENT_START: 'PARTICIPANT_ASSIGNMENT_START',
            PARTICIPANT_ASSIGNMENT_SUCCESS: 'PARTICIPANT_ASSIGNMENT_SUCCESS',
            PARTICIPANT_ASSIGNMENT_FAILED: 'PARTICIPANT_ASSIGNMENT_FAILED',
            PARTICIPANT_ASSIGNMENT_END: 'PARTICIPANT_ASSIGNMENT_END',
            PARTICIPANT_DETACHMENT_START: 'PARTICIPANT_DETACHMENT_START',
            PARTICIPANT_DETACHMENT_SUCCESS: 'PARTICIPANT_DETACHMENT_SUCCESS',
            PARTICIPANT_DETACHMENT_FAILED: 'PARTICIPANT_DETACHMENT_FAILED',
            PARTICIPANT_DETACHMENT_END: 'PARTICIPANT_DETACHMENT_END',
        },
    },
    {
        actionName: 'sidebarAction',
        types: {
            OPEN_SIDEBAR: 'OPEN_SIDEBAR',
            CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
            TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
            RESET_SIDEBAR: 'RESET_SIDEBAR',
        },
    },
    {
        actionName: 'notificationAction',
        types: {
            NOTIFICATION_SEND_START: 'NOTIFICATION_SEND_START',
            NOTIFICATION_SEND_SUCCESS: 'NOTIFICATION_SEND_SUCCESS',
            NOTIFICATION_SEND_FAILED: 'NOTIFICATION_SEND_FAILED',
            NOTIFICATION_SEND_STOP: 'NOTIFICATION_SEND_STOP',
        },
    },
];
